<template>
  <span class="bg-blue-1 fill-blue-60 rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="inherit" viewBox="0 0 24 24">
      <path
        fill="inherit"
        d="M11.5 16.5h1V11h-1zm.5-6.92a.6.6 0 0 0 .44-.18.6.6 0 0 0 .18-.44.6.6 0 0 0-.18-.44.6.6 0 0 0-.44-.17.6.6 0 0 0-.44.17.6.6 0 0 0-.18.44q0 .26.18.44a.6.6 0 0 0 .44.18M12 21a9.1 9.1 0 0 1-8.3-5.49 9 9 0 0 1-.7-3.5q0-1.87.7-3.52A9 9 0 0 1 8.5 3.71q1.64-.7 3.5-.71 1.87 0 3.52.7a9 9 0 0 1 4.78 4.79q.7 1.64.71 3.5 0 1.87-.7 3.52a9 9 0 0 1-4.79 4.78q-1.64.7-3.5.71m0-1q3.35 0 5.68-2.32A7.7 7.7 0 0 0 20 12q0-3.34-2.32-5.67A7.7 7.7 0 0 0 12 4Q8.66 4 6.33 6.33A7.7 7.7 0 0 0 4 12q0 3.35 2.33 5.68A7.7 7.7 0 0 0 12 20"
      />
    </svg>
  </span>
</template>
